export default {
    resultadoBuscaTodosServicosAtendimento: {
        filtros: {
            atendimentoId: {
                default: null,
                value: ''
            },
        },
        paginacao: {
            page: 1,
            size: 10,
            sort: 'dataCadastro',
            direction: 'ASC',
        }
    },
}